import React from "react";

const HeaderLogo = () => (
  <img src="/images/footik-dark.png" width="60" height="60" />
);

export default HeaderLogo;
